import React from 'react'
import { setOutlineContainerId } from 'data/ui/actions'
import { useDispatch, batch } from 'react-redux'
import classNames from 'classnames'

import ExitButton from './ExitButton'

const CONTAINER_ID = 'META_PANEL_OUTLINE_CONTAINER'

// This component purpose is to provide a container for the outline portal
// where the outline plugin will push the outline itself
export default function OutlinePanel() {
  const dispatch = useDispatch()
  React.useEffect(
    function onMount() {
      batch(() => {
        dispatch(setOutlineContainerId(CONTAINER_ID))
      })
      return function onUnmount() {
        batch(() => {
          dispatch(setOutlineContainerId(null))
        })
      }
    },
    [dispatch]
  )

  return (
    <div
      className={classNames(
        'l-meta u-grid-cell-size-limit overflow-hidden',
        'slite-design-system flexbox flexbox-column background-shade-100',
        'zindex-large height-full border-left-medium border-shade-50'
      )}
    >
      <div className="padding-horizontal-large flexbox-no-shrink">
        <div
          className="flexbox flexbox-align-center flexbox-space-between border-bottom-medium border-shade-50"
          style={{ height: 60 }}
        >
          <div className="font-size-large bold" style={{ fontSize: '16px' }}>
            Table of contents
          </div>
          <ExitButton />
        </div>
      </div>
      <div
        id={CONTAINER_ID}
        className="scrollable padding-horizontal-large padding-vertical-normal max-height-full"
      />
    </div>
  )
}
